<template>
	<div>
		<Header />

		<div id="dash-account" class="section titles wf-section start">
			<div class="container w-container">
				<div class="heading-wrapper-center padding-bottom-medium">
					<h2 class="heading-large">Mitt konto</h2>
				</div>
				<div class="w-layout-grid main-grid">
					<div id="w-node-_9e4eb399-aa76-58f0-e088-2fd094e40186-94e40185" class="gray-wrapper">
						<div class="paragraph-wrapper">
							<h2 class="heading-medium left">Välkommen</h2>
							<h2 class="heading-medium left text-white-opacity">{{ this.user.data.displayName }}</h2>

							<p class="main-paragraph text-white left"><br>{{ details.address }}</p>
							<p class="main-paragraph text-white left">Phone : {{ details.phone }}</p>
							<p class="main-paragraph text-white left">Mobile : {{ details.mobilePhone }}</p>
							<p class="main-paragraph text-white left">Email : {{ email }}</p>

						</div>
					</div>
					<div id="w-node-_9e4eb399-aa76-58f0-e088-2fd094e40188-94e40185"
						class="w-layout-grid grid-stats gap">
						<div class="gray-wrapper">
							<div class="w-layout-grid content-grid gap-short">
								<h3>{{ plan.name }}</h3>
								<p class="p-small-size"> Giltig tills:<br>{{ planEndDateVerbose }}</p>
							</div>
						</div>
						<div class="gray-wrapper">
							<div class="w-layout-grid content-grid gap-short">
								<h3>Bil</h3>
								<p class="p-small-size">{{ car.description }}<br>Plate: {{ car.plate }}</p>
							</div>
						</div>
						<div class="gray-wrapper">
							<div class="w-layout-grid content-grid gap-short">
								<h3>Bokningar</h3>
								<p class="p-small-size"><span class="text-white">
									{{ upComingBookings }} Uppkommande Bokningar</span><br>Totalt {{ bookings.length }} Bokningar</p>
							</div>
						</div>


						<div class="gray-wrapper">
							<div class="w-layout-grid content-grid gap-short">
								<h3>Företag</h3>
								<p class="p-small-size">{{ company.name }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="dash-book" class="section titles wf-section">
			<div class="container w-container">
				<div class="heading-wrapper-center padding-bottom-medium">
					<h2 class="heading-large">Boka en tjänst</h2>
				</div>
				<div class="w-layout-grid main-grid">
					<div id="w-node-_49fa2cc8-0054-088c-5e48-6ba0626d46a5-bb8c2943" class="gray-wrapper">
						<div class="w-layout-grid content-grid">
							<div class="icon-wrapper"><img src="/img/icons/ic-002-color.svg" loading="lazy" alt=""
									class="icon-content"></div>
							<div class="small-paragraph-wrapper">
								<h3 class="heading-regular">In-och utvändig tvätt</h3>
								<p class="main-paragraph margin-bottom-xsmall">Boka tid för en detaljerad och noggrann tvätt.</p>
								<div class="list-wrapper">
									<div v-if="canBookWash">
										<a :href="'/book/wash'" class="button color-red w-inline-block">
											<div>Boka Tid</div>
										</a>
									</div>
									<div v-else class="errors" v-html="errorBookWash">
										<!--{{ errorBookWash }}-->
									</div>
								</div>
							</div>
						</div>
					</div>


					<div id="w-node-_49fa2cc8-0054-088c-5e48-6ba0626d46ae-bb8c2943" class="gray-wrapper">
						<div class="w-layout-grid content-grid">
							<div class="icon-wrapper"><img src="/img/icons/ic-006-color.svg" loading="lazy" alt=""
									class="icon-content"></div>
							<div class="small-paragraph-wrapper">
								<h3 class="heading-regular">Däckbyte och hotell</h3>
								<p class="main-paragraph margin-bottom-xsmall">Boka tid för att komma in och byta dina däck eller förvara de hos oss.</p>
								<div class="list-wrapper">
									<div v-if="canBookTires">
										<a :href="'/book/tires'" class="button color-red w-inline-block">
											<div>Boka Tid</div>
										</a>
									</div>
									<div v-else class="errors">
										{{ errorBookTires }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="w-node-_49fa2cc8-0054-088c-5e48-6ba0626d46b7-bb8c2943" class="gray-wrapper">
						<div class="w-layout-grid content-grid">
							<div class="icon-wrapper"><img src="/img/icons/ic-003-color.svg" loading="lazy" alt=""
									class="icon-content"></div>
							<div class="small-paragraph-wrapper">
								<h3 class="heading-regular">Keramisk Ceramic Coat</h3>
								<p class="main-paragraph margin-bottom-xsmall">Boka tid för att ge din bil den bästa keramiska behandlingen.</p>
								<div class="list-wrapper">
									<div v-if="canBookCeramic">
										<a :href="'/book/ceramic'" class="button color-red w-inline-block">
											<div>Boka Tid</div>
										</a>
									</div>
									<div v-else class="errors">
										{{ errorBookCeramic }}<br>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div v-if="bookings.length" id="dash-past" class="section titles wf-section">
				<div class="container w-container">
					<div class="w-layout-grid main-grid">
						<div id="w-node-e2859498-0993-2f9f-534e-3b34e3fb87e5-e3fb87e4" class="grid-wrapper">
							<h3 class="heading-medium text-white past">Mina bokningar</h3>
							<h4 class="heading-small past">Avbokning sker minst 24 timmar innan ditt bokade möte</h4>
						</div>
						<div id="w-node-e2859498-0993-2f9f-534e-3b34e3fb87e8-e3fb87e4" class="grid-wrapper">

							<div class="tabs-menu-vertical">
								<!--<div v-for="booking in bookings" class="bookings-list" v-bind:class="{ 'w--current': booking.canCancel, '': !booking.canCancel }">-->
								<div v-for="booking in bookings" class="bookings-list">
									<div class="w-layout-grid norowgap">
										<div class="vertical">
											<div>
												<h3 class="heading-small text-white">{{ booking.bookingTitle }}</h3>
											</div>
											<div class="wrapper-text-opacity">
												<div>{{ booking.date.toDate().toLocaleString('sv-SE', {
														weekday: 'long',
														year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit',
														minute: '2-digit'
													}).toUpperCase()
												}}</div>
											</div>
										</div>
										<div v-if="booking.canCancel" class="button w-inline-block color-red fixtures cancelBtn"
											@click="showCancelModal(booking)">
											<div>Avboka</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<Footer />

	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Swal from 'sweetalert2'
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
	name: 'Dashboard',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			bookings: [],
			company: {},
			car: {},
			details: {},
			plan: {},
			planEndDate: '',
			planEndDateVerbose: '',
			email: '',
			canBookWash: false,
			canBookTires: false,
			canBookCeramic: false,
			errorBookWash: 'Denna tjänst ingår inte i ditt paket',
			errorBookTires: 'Denna tjänst ingår inte i ditt paket',
			errorBookCeramic: 'Denna tjänst ingår inte i ditt paket',
			upComingBookings: 0
		}
	},
	computed: {
		...mapGetters({
			user: "user"
		}),
	},
	async created() {
		this.$root.isLoading = true;
		this.loadUserData();
	},
	methods: {
		...mapActions('bookings', ['cancel']),
		...mapActions(['getUserData']),
		loadUserData: async function () {
			await this.getUserData();
			this.company = this.user.extra.company;

			this.bookings = this.user.extra.bookings;
			this.bookings.sort((a, b) => {
				let da = new Date(a.date.toDate()),
					db = new Date(b.date.toDate());
				return db - da;
			});

			this.plan = this.user.extra.plan;
			this.planEndDate = this.user.extra.planEndDate.toDate();			
			this.planEndDateVerbose = this.user.extra.planEndDate.toDate().toLocaleString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric' }).toUpperCase();

			this.car = this.user.extra.car;
			this.details = this.user.extra.details;
			this.email = this.user.extra.email;

			let nowDate = new Date(Date.now());
			let tomorrowDate = new Date(Date.now() + (3600 * 1000 * 24));
			var that = this;
			this.upComingBookings = 0;
			
			this.bookings.forEach(function (item, index) {
				let bookingDate = item.date.toDate();
				item.canCancel = false;
				if (bookingDate > nowDate) {
					that.upComingBookings = that.upComingBookings+1;
				}
				if (bookingDate > tomorrowDate) {
					//console.log("future"+bookingDate);
					item.canCancel = true;
				}
				//item.canCancel = true;
			});
			this.checkPermissions();
			this.$root.isLoading = false;
		},
		checkPermissions: function () {
			var nowDate = new Date(Date.now());
			if (this.planEndDate < nowDate) {
				return
			}
			var canBookWash = this.plan.wash;
			var canBookTires = this.plan.tires;
			var canBookCeramic = this.plan.ceramic;

			let washBookings = [];
			let tiresBookings = [];
			let ceramicBookings = [];

			this.bookings.forEach(function (item, index) {
				if (item.bookingType == "wash") {
					washBookings.push(item);
				}
				if (item.bookingType == "tires") {
					tiresBookings.push(item);
				}
				if (item.bookingType == "ceramic") {
					ceramicBookings.push(item);
				}
			});

			if (washBookings.length > 0) {
				//nowDate.setMonth(nowDate.getMonth() + 1);
				var nowMonth = nowDate.getMonth();
				var nowYear = nowDate.getYear();

				var nextMonthDate = new Date(Date.now());
				nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
				var that = this;
				washBookings.forEach(function (item, index) {
					var bookingDate = item.date.toDate();
					var bookingMonth = bookingDate.getMonth();
					var bookingYear = bookingDate.getYear();
					if ( bookingMonth == nowMonth && bookingYear == nowYear ){
						canBookWash = false;
						that.errorBookWash = "Du har redan använt denna tjänst den här månaden. Prova igen i " + nextMonthDate.toLocaleString('sv-SE', { month: 'long' }) + ".";
					}
				});
				
				// var latestBooking = washBookings[0].date.toDate();
				// var latestMonth = latestBooking.getMonth();
				//if (latestMonth == nowMonth) {
			}

			if (tiresBookings.length > 0) {
				var latestBooking = tiresBookings[0].date.toDate();
				var fourMonthsDate = tiresBookings[0].date.toDate();
				fourMonthsDate.setMonth(fourMonthsDate.getMonth() + 4);
				if (fourMonthsDate > nowDate) {
					canBookTires = false;
					this.errorBookTires = "Du har redan använt denna tjänst de senaste 4 månaderna";
				}
			}

			if (ceramicBookings.length > 0) {
				canBookCeramic = false;
				this.errorBookCeramic = "Du har redan använt denna tjänst";
			}
			//let bookingDate = item.date.toDate();
			if (this.plan.ceramic && canBookCeramic) {
				this.canBookCeramic = true;
			}
			if (this.plan.tires && canBookTires) {
				this.canBookTires = true;
			}
			if (this.plan.wash && canBookWash) {
				this.canBookWash = true;
			}
		},
		showCancelModal: function (booking) {
			Swal.fire({
				title: "Bekräfta avbokning",
				html: "Bekräfta avbokning:<br>" + booking.bookingTitle + " on " + booking.date.toDate().toLocaleString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).toUpperCase(),
				icon: "question",
				iconColor: "#ff0062",
				showCancelButton: !0,
				background: "#464646",
				color: "#ffffff",
				confirmButtonColor: "#6411ff",
				cancelButtonColor: "#ff0062",
				confirmButtonText: "Ja, forsätt!",
				cancelButtonText: "Nej, avboka!",
				buttonsStyling: true
			}).then((result) => {
				if (result.value) {
					this.cancelBooking(booking);
				}
			});
		},
		cancelBooking: function (booking) {
			this.$root.isLoading = true;
			//CREATE BOOKING
			this.cancel(booking).then(id => {
				this.$root.isLoading = false;
				this.loadUserData();
				Swal.fire({
					title: "Din bokning har avbokats!",
					text: "ID: " + id,
					icon: "success",
					showConfirmButton: false,
					background: "#464646",
					color: "#ffffff",
					timer: 2000
				});
			});
		}
	}
};
</script>
<style scoped>
h4.past {
	font-size: 16px;
	padding-bottom: 12vh;
}
@media screen and (max-width: 991px) {
	.past {
		min-height: auto;
		font-size: 32px;
		padding-bottom: 0vh;
		text-align: center;
	}
	h4.past {
		font-size: 16px;
		padding-bottom: 8vh;
	}
}
@media screen and (max-width: 767px) {
	/*h3 {
	    font-size: 18px;
    	line-height: 1.4
	}*/
	.w-layout-grid {
		grid-template-columns:1fr;
	}
	.cancelBtn{
		margin-top: 20px;
	}
}
.cancelBtn{
	margin-left:auto;
}
.bookings-list {
	margin-right: 0;
	margin-bottom: 20px;
	margin-left: 0;
	padding: 25px 20px;
	border-radius: 5px;
	background-color: #222;
	color: #fff;
	font-size: 14px;
	line-height: 1.4;
	text-align: left;
}

.norowgap {
	grid-row-gap: 0px;
}

.vertical {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: left;
	text-align: left;
}
.errors {
	color:#ff0062;
	font-size: 18px;
	line-height: 30px;
}
</style>